import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    question: {
      marginTop: 10,
    },
  }));

const ReturnDialogContent = ({ status, handleIade, job, newStatus }) => {
  const classes = useStyles();
  if (status === '0') {
    return (
      <>
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">
            Müşterinin iade etmek istediği ürün müşteriden alındı mı?
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            onChange={(event) => handleIade(event.target.value, job, newStatus)}
          >
            <FormControlLabel value="1" control={<Radio />} label="Evet" />
            <FormControlLabel value="2" control={<Radio />} label="Hayır" />
          </RadioGroup>
        </FormControl>
      </>
    );
  } else if (status === '2') {
    return (
      <>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            onChange={(event) => handleIade(event.target.value, job, newStatus)}
          >
            <FormControlLabel value="0" control={<Radio />} label={<Typography variant="h6">Yanlışlıkla HAYIR işaretledim</Typography>} />
            <FormControlLabel value="4" control={<Radio />} label="Ürün iade alımına uygun değildir (kırık, farklı ürün vb.)" />
          </RadioGroup>
        </FormControl>
      </>
    );
  } else if (status === '1') {
    return (
      <>
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">
            Müşteriden iade alınan ürünün sorumluluğu ilgili yetkili servisimize aittir.
            Müşteriye ücret iadesinin ödemeyi yapmış olduğu kredi kartına / banka kartına yapılacağı bilgisini veriniz.
            Müşteri bu konuda SMS ile bilgilendirilecektir.
            <br/>
            <Typography className={classes.question} variant="h6">Emin misiniz ?</Typography>
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            onChange={(event) => handleIade(event.target.value, job, newStatus)}
          >
            <FormControlLabel value="7" control={<Radio />} label="Evet" />
            <FormControlLabel value="0" control={<Radio />} label="Hayır" />
          </RadioGroup>
        </FormControl>
      </>
    );
  } else {
    // Handle default case if needed
    return <></>;
  }
};

export default ReturnDialogContent;
